import { render, staticRenderFns } from "./JAvatar.vue?vue&type=template&id=7827504a&scoped=true&"
import script from "./JAvatar.vue?vue&type=script&lang=js&"
export * from "./JAvatar.vue?vue&type=script&lang=js&"
import style0 from "./JAvatar.vue?vue&type=style&index=0&id=7827504a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7827504a",
  null
  
)

export default component.exports